(function ($) {

  lightbox = new SimpleLightbox('.fl-gallery', {
    animationSlide: false,
    animationSpeed: 0,
    heightRatio: 0.95,
    widthRatio: 0.9,
    overlayOpacity: 1,
    captions: true,
    captionSelector: "self",
    fadeSpeed: 0, 
    sourceAttr: "data-href"
  });

  $('body').on('click', '.open-gallery', function(e) {
    e.preventDefault();
    lightbox.open(this);
  })

  $('.top-nav .search').on('click', function(e){
    e.stopPropagation();
    var $this = $(this);
    $this.addClass('is-open');

    if($this.hasClass('empty')) {

      $.ajax({
          dataType: 'json',
          type: 'post',
          url: '/yachts-by-name',
          success: function(res) {
              if(res) {

                var items = '';

                res.forEach(function(boat, index){
                    items += '<li>';
                    items += '<a href="' + boat.url + '">' + boat.name + '</a>';
                    items += '</li>';
                });

                $this.removeClass('empty')
                     .find('.submenu')
                     .html(items);

                $('.top-nav .submenu').scrollbar({
                  disableBodyScroll: true,
                });

              }
          }
      });

    }

  });

  $(document).click(function(e){
    if (!$(e.target).closest(".search").length) {
      $(".top-nav .search").removeClass('is-open');
    }
    if (!$(e.target).closest(".language-switcher").length) {
      $(".top-nav .language-switcher").removeClass('is-open');
    }
  });

  $('.top-nav .language-switcher').on('click', function(e){
    e.stopPropagation();
    var $this = $(this);
    $this.toggleClass('is-open');
  });


  $('.boats-slider').flexslider({
    animation  : "slide",
    controlNav : false,
    prevText   : "",
    nextText   : "",
    //smoothHeight: true
  });


  $('.toggle-menu').on('click', function(){

    $(this).toggleClass('active');
    $('.top-nav').slideToggle();

  });

  $('.back-to-top').on('click', function(){

    var pos = $('.boats-listing').offset().top - 20;
    $("html, body").animate({scrollTop: pos}, "slow");

  });

  $('.search-mobile a').on('click', function(e){

    $('.search-submenu').toggleClass('is-open');


	/*e.preventDefault();

    var anchor = $(this).attr('href');
    var pos = $(anchor).offset().top;
    $("html, body").animate({scrollTop: pos}, "slow");

    $('.top-nav').slideToggle();
    $('.toggle-menu').toggleClass('active');*/

  });

  /**
   *   CONTACT FORM
   */

  $.validate({
    form : '#enquiry',
    borderColorOnError : '',
    scrollToTopOnError : false,
    onError : function($form) {

    },
    onSuccess : function($form) {

      grecaptcha.execute();
      return false;

    },
    onElementValidate : function(valid, $el, $form, errorMess) {
      if(!$form.find('.error').length) {}
    }
  });

  /**
   *   GOOGLE MAP
   */

   $('.gmap').each(function(){

    render_map( $(this) );

  });

  var map, marker;

  function render_map( $el ) {

    // var
    var $markers = $el.find('.marker');
          $el.addClass('activated');

    // vars

    var map_settings_gray = [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}];

    var args = {
      zoom    : 15,
      center    : new google.maps.LatLng(0, 0),
      scrollwheel: false,
      styles: map_settings_gray,
      mapTypeId : google.maps.MapTypeId.ROADMAP
    };

    // create map
    map = new google.maps.Map( $el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function(){

        add_marker( $(this), map );

    });

    // center map
    center_map( map );

  }

  function add_marker( $marker, map ) {

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker

    marker = new google.maps.Marker({
      position  : latlng,
      map : map,
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content   : $marker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function() {

        infowindow.open( map, marker );

      });
    }

  }

  function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

      bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
      // set center of map
        map.setCenter( bounds.getCenter() );
        map.setZoom( 15 );
    }
    else
    {
      // fit to bounds
      map.fitBounds( bounds );
    }

  }

  $('.layer .close').on('click', function(){

    $('.layer').fadeOut();

  });

  $('.show-map').on('click', function(){

    $('.layer').fadeIn();

      google.maps.event.trigger(map, 'resize');
      center_map(map);

  });

}(jQuery));


function ContactFormSubmit() {

      var $form = $('#enquiry');
      var $loader = $form.find('.loader'),
          $alerts = $form.find('.alert');

      $loader.fadeIn();
      $alerts.fadeOut();

      $.post( $form.attr('action'), $form.serialize(), function(data) {

        if (data && data.errors) {
            var errors = '';

            data.errors.forEach (function (error, index) {
                errors += '<p>'+ error +'</p>';
            });

            $form.find('.alert-error').html(errors).fadeIn();
        }
        else {
          $form.find('.form-control').val('');
          $form.find('.alert-success').fadeIn();
        }

        $loader.fadeOut();
        grecaptcha.reset();

      });

  }
